<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					 <el-select v-model="filters.jumpCode" clearable placeholder="请选择跳转页" >
                        <el-option  v-for="(item,index) in options" :key="index"  :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.paramName" placeholder="参数名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getParams">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="params" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		 :header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="jump_name" label="跳转页" width="120">
			</el-table-column>
			<el-table-column prop="param_name" label="参数名" width="120" >
			</el-table-column>
			<el-table-column prop="param_value" label="参数值"width="220"  >
			</el-table-column>
			<el-table-column label="操作" >
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[10, 20, 30, 40,50]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false"  size="tiny">
			<el-form :model="editForm"   label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="跳转页" prop="jump">
					 <el-select v-model="editForm.jump"  placeholder="请选择" >
                        <el-option  v-for="(item,index) in options" :key="index" :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				</el-form-item>
				<el-form-item label="参数名" prop="param_name">
				     <el-input v-model="editForm.param_name" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="参数值" prop="param_value">
					 <el-input v-model="editForm.param_value" auto-complete="off" ></el-input>
				</el-form-item>	
			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getParamListPage,addParam,editParam, removeParam,batchRemoveParam,getJump } from '../../api/api';
   
  

 let CurrentUserID="",Session=""; 
	export default {
	
		data() {
			return {
				
				filters: {
					jumpCode: '',
					paramName:''

				},
				options: [],
				params: [],
				total: 0,
				pageSize:10,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					jump: [
						{ required: true, message: '请选择跳转页', trigger: 'blur' }
					],
					param_name: [
						{ required: true, message: '请输入参数名', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					jump: '',
					param_name: '',
					param_value:''
				},

				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getParams();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getParams();
			
			},
			//获取用户列表
			getParams() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					paramName:this.filters.paramName,
					jumpCode:this.filters.jumpCode,
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getParamListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.paramlist.total;
					         this.params = res.data.paramlist.params;
					         this.listLoading = false;
                           
                         }
                         else{   
							  this.listLoading = false;
                              if (res.data.result_code==911)
							  {

                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
								this.$message({
									message:'接口错误',
									type: 'error'
								});

							  }

                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问接口失败',
                                type: 'error'
                              });
                       this.listLoading = false;
                   }
           )






			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session};


                   this.$http.jsonp(removeParam, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getParams();
                           
                         }
                         else{  

							 this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有权限删除',
                                type: 'error'
                              });
							}

                            
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问接口失败',
                                type: 'error'
                              });
                     this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
	
				this.formStatus=1;
				this.editFormVisible = true;
			    this.editForm = {
					id: 0,
					jump: '',
					param_name: '',
					param_value:''
				};
				
				this.editForm = Object.assign({}, row);            
			  
				//this.$refs['editForm'].resetFields();
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				this.editFormVisible = true;
				
				this.editForm = {
					id: 0,
					jump: '',
					param_name: '',
					param_value:''
				};
                if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }	
				
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;

			   let paramUrl=addParam;			  
               if (this.formStatus==1)
			   {
                  paramUrl=editParam;
			   }
                this.$http.jsonp(paramUrl, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							    
							   		this.editForm = {
										id: 0,
										jump: '',
										param_name: '',
										param_value:''
									};
							   	if (this.$refs['editForm'] !== undefined) {						
									this.$refs['editForm'].resetFields();
								}
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getParams();
                           
                         }
                         else{                           
                            
							 this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'错误',
                                type: 'error'
                              });
                      this.editLoading = false;	
                   }
           )

						});
					}
				});
			},
			
			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getParams();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };


                   this.$http.jsonp(batchRemoveParam, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getParams();
                           
                         }
                         else{                           
                                this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
			this.$http.jsonp(getJump,{params: {CurrentUserID:CurrentUserID,Session:Session}}).then(
			function(res){                         
					if (res.data.result_code==200)
					{						
						this.options=res.data.jumps;					
					}
					else{                           
						this.$message({
						message:'获取跳转页错误',
						type: 'error'
						});

						if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'获取项目分组跳转页错误',
										type: 'error'
									});
                                  return;
							  }

					
					}
				

			},
			function(res)
			{
				this.$message({
						message:'获取跳转页错误',
						type: 'error'
						});
				
			});

			this.getParams();


		}
	}

</script>

<style scoped>
  .el_input_width{
	 width:220px; 
  }
</style>


// WEBPACK FOOTER //
// jumpparam.vue?4b629b80